import { render, staticRenderFns } from "./GoodsDetailView.vue?vue&type=template&id=157a6166&scoped=true"
import script from "./GoodsDetailView.vue?vue&type=script&lang=js"
export * from "./GoodsDetailView.vue?vue&type=script&lang=js"
import style0 from "./GoodsDetailView.vue?vue&type=style&index=0&id=157a6166&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157a6166",
  null
  
)

export default component.exports